export default "__VITE_ASSET__Bmi657HC__"